import React from 'react';
import { whyChooseUsItemList } from './data';

export default function WhyChooseUs() {
  return (
    <section className="why-choose-us">
      <div className="why-choose-us__container">
        <header className="why-choose-us__header">
          <h2 className="why-choose-us__heading">COMMITED TO YOUR SUCCESS</h2>
          <h3 className="why-choose-us__title">Why choose us?</h3>
          <p>
            What set bravoSUITE apart is that we can deliver all the below on
            one centralized platform:
          </p>
        </header>
        <ul className="why-choose-us__content">
          {whyChooseUsItemList.map((item) => (
            <li key={item.id} className="why-choose-us__item">
              <img src={item.icon} alt={item.description} />
              <p>{item.description}</p>
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
